	
	var p//UAParser
      ,r//rst
      ,st=Date.now(),tm=window.setInterval('tc(r,st);',3000)
      ,t=0// timer time
      ,ua=navigator.userAgent
      ;
    if(null!=ua){
      ua=ua.toLowerCase();
//console.log(ua);
      if(!ua.includes('googlebot') && 
         !ua.includes('bingbot') && 
         !ua.includes('baiduspider') && 
         !ua.includes('baiduspider') && 
         !ua.includes('applebot') && 
         !ua.includes('naver') && // facebook
         !ua.includes('facebook') && 
         !ua.includes('yisoupider') && 
         !ua.includes('sogou') && 
         !ua.includes('360spider') && 
         !ua.includes('soso') && 
         !ua.includes('yahoo') && 
         !ua.includes('ahrefsbot') && 
         !ua.includes('bitdiscovery') && 
         !ua.includes('trustpilot-websitescreenshotcreator') && 
         !ua.includes('google-inspectiontool') && 
         !ua.includes('claudebot') && 
         !ua.includes('headless')
        ){
//console.log(ua);
          p = new UAParser();
          r = p.setUA(navigator.userAgent).getResult();
    	  if(null!=r){       
              r['utc']=st;
    		  r['page_url'] = window.location.href;        
    		  r['referrer_url'] = document.referrer;
    		  r['referrer_site'] = document.referrer.replace(/https?:\/\//i,'').replace(/(\/.*)|(:\d+.*)/g,'');		
    	  }
          s(r);//send rst
      }
    }
//console.log(encodeURI(JSON.stringify(r)));
  function tc(rst,st){
      switch(t){
        case 0:case 10:case 60:case 200:d(rst,st);break;
        case 201:window.clearInterval(tm);
      }
      ++t;
    }

    function d(rst,st){//send rst include time keep
        rst['visit_duration']=Math.round((Date.now()-st)/1000);
        s(rst);
    }
    function s(rst){//send rst;
      fetch('https://www.linkgenchem.com/ipsrv/alivisit',
		{
			headers:{'Content-Type':'application/x-www-form-urlencoded'}
            ,method:'POST'
            ,mode:'no-cors'
            ,body:'ua='+encodeURI(JSON.stringify(rst)).replace(/\+/g,"%2B").replace(/\&/g,"%26")
		}
      );
    }
  